import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";
import IosShareIcon from "@mui/icons-material/IosShare";
import usePwaInstall from "../../hooks/usePwaInstall";
import { isAdminRoute } from "../../utils/isAdminRoute";
import {
  bannerStyles,
  closeButtonStyles,
  contentStyles,
  dialogStepStyles,
  installButtonStyles,
  subtitleStyles,
  titleStyles,
} from "./styles";

const IOS_INSTALL_STEPS = [
  'Tap the Share button in Safari or Edge (the square with an arrow).',
  'Scroll the menu and tap "Add to Home Screen".',
  'Tap "Add" to install Coachmate on your device.',
];

const InstallAppBanner = () => {
  const { canInstall, installVariant, install, dismiss } = usePwaInstall();
  const [iosGuideOpen, setIosGuideOpen] = useState(false);

  if (!canInstall || isAdminRoute()) {
    return null;
  }

  const isIosInstall = installVariant === "ios";

  const handleInstallClick = () => {
    if (isIosInstall) {
      setIosGuideOpen(true);
      return;
    }

    void install();
  };

  return (
    <>
      <Box sx={bannerStyles} role="region" aria-label="Install app">
        <Box sx={contentStyles}>
          <InstallMobileIcon sx={{ flexShrink: 0 }} />
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={titleStyles}>Install Coachmate</Typography>
            <Typography sx={subtitleStyles}>
              {isIosInstall
                ? "Add Coachmate to your home screen for faster access and app-like experience."
                : "Add to your home screen for faster access and app-like experience."}
            </Typography>
          </Box>
        </Box>
        <Button sx={installButtonStyles} onClick={handleInstallClick}>
          Install
        </Button>
        <IconButton
          sx={closeButtonStyles}
          aria-label="Dismiss install prompt"
          onClick={dismiss}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Dialog
        open={iosGuideOpen}
        onClose={() => setIosGuideOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IosShareIcon color="primary" />
          Install on iPhone or iPad
        </DialogTitle>
        <DialogContent>
          {IOS_INSTALL_STEPS.map((step, index) => (
            <Typography key={step} sx={dialogStepStyles}>
              {index + 1}. {step}
            </Typography>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIosGuideOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InstallAppBanner;
